import React, { Component } from 'react';



class music extends Component {
    // state = {

    // }
    // handleChange = (e) => {
    //     console.log(e);
    // }
    // handleSubmit = (e) => {
    //     console.log(e);
    // }
    render() {

        return (
            <section>

            <section className="container section" id="tabs">
            <div className="scrollspy" id="top">
            <div className="row">
                <div className="col s12 l8 offset-l2">
                    <ul className="tabs">
                        <li className="tab">
                            <a href="#one-person-ensemble" className="active black-text">
                                One-Person Ensemble
                            </a>
                        </li>
                        <li className="tab"><a href="#guzheng" className="black-text">GuZheng</a></li>
                        <li className="tab"><a href="#guitar" className="black-text">Guitar</a></li>
                        <li className="tab"><a href="#piano" className="black-text">Piano</a></li>
                        <li className="tab"><a href="#kalimba" className="black-text">Kalimba</a></li>
                        <li className="tab"><a href="#guitarlele" className="black-text">Guitarlele</a></li>
                    </ul>
                </div>
            </div>
            </div>
            </section>

            <section className="container section" id="one-person-ensemble">
              <div className="row">
                <div className="col s12 m6 l3">
                    <div className="video" id="video1">
                        <video controls src="../one-person-ensemble/2.mp4" width="250" height="350"></video>
                    </div>
                </div>

                <div className="col s12 m6 l3">
                     
                </div>

                <div className="col s12 m6 l3">
             
                </div>

                <div className="col s12 m6 l3">
              
                </div>
             </div>
            </section>   

            <section className="container section" id="guzheng">
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="video" id="video2">
                        <video controls src="../guzheng/雪山春晓.mp4" width="200" height="280"></video>
                    </div>
                </div>

                <div className="col s12 m6 l3">
                    <div className="video" id="video3">
                        <video controls src="../guzheng/月儿高.mp4" width="200" height="280"></video>
                    </div>
                </div>

                <div className="col s12 m6 l3">
                    <div className="video" id="video4">
                        <video controls src="../guzheng/高山流水.mp4" width="200" height="280"></video>
                    </div>
                </div>

                <div className="col s12 m6 l3">
                    <div className="video" id="video5">
                        <video controls src="../guzheng/梅花三弄.mp4" width="200" height="280"></video>
                    </div>
                </div>
            </div>
 
            </section>   

            <section className="container section" id="guitar">

            <div className="row">
                <div className="col s12 m6 l3">
                    {<div className="video" id="video6">
                        <video controls src="../guitar/茉莉雨-new.mp4" width="250" height="350"></video>
                    </div>}
                </div>

                <div className="col s12 m6 l3">
                    {<div className="video" id="video7">
                        <video controls src="../guitar/ComingHome.mp4" width="250" height="350"></video>
                    </div>}
                </div>

                <div className="col s12 m6 l3">
                    {<div className="video" id="video8">
                        <video controls src="../guitar/无羁.mp4" width="250" height="350"></video>
                    </div>}
                </div>

                <div className="col s12 m6 l3">
                    {<div className="video" id="video9">
                        <video controls src="../guitar/泪桥.mp4" width="250" height="350"></video>
                    </div>}
                </div>
            </div>

            </section>   

            <section className="container section" id="piano">
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="video" id="video10">
                        <video controls src="../piano/梦中的婚礼.mp4" width="250" height="350"></video>
                    </div>
                </div>

                <div className="col s12 m6 l3">
                    <div className="video" id="video11">
                        <video controls src="../piano/想自由.mp4" width="250" height="350"></video>
                    </div>
                </div>

                <div className="col s12 m6 l3">

                </div>

                <div className="col s12 m6 l3">

                </div>
            </div>
  
            </section>   

            <section className="container section" id="kalimba">
              <div className="row">
                <div className="col s12 m6 l3">
                    <div className="video" id="video12">
                        <video controls src="../kalimba/大鱼.mp4" width="250" height="350"></video>
                    </div>
                </div>

                <div className="col s12 m6 l3">
                     
                </div>

                <div className="col s12 m6 l3">
             
                </div>

                <div className="col s12 m6 l3">
              
                </div>
             </div>
            </section>   

            <section className="container section" id="guitarlele">
              <div className="row">
                <div className="col s12 m6 l3">
                    <div className="video" id="video13">
                        <video controls src="../guitarlele/无羁.mp4" width="250" height="350"></video>
                    </div>
                </div>

                <div className="col s12 m6 l3">
                     
                </div>

                <div className="col s12 m6 l3">
             
                </div>

                <div className="col s12 m6 l3">
              
                </div>
             </div>
            </section>  

            </section>
        )
    }
}





export default music
